import React from 'react';
import StoreButtons from './StoreButtons';

// Same dark band as the home page download section, worded for pupils
function DownloadPupilApp() {
    return (
        <section className="dd-testimonial-area dd-download-cta pt-100 pb-100" id="download">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="dd-download-cta-content text-center">
                            <span>Free for pupils</span>
                            <h3 className="title">Download the pupil app</h3>
                            <p>
                                Get the app for iPhone or Android, then log in with the mobile number
                                your instructor has for you.
                            </p>
                            <StoreButtons className="dd-download-cta-btns" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default DownloadPupilApp;
